import type { CCategoryAdvertisementTranslations } from "./pl";

export const en: CCategoryAdvertisementTranslations = {
  emptyData: "No data to display.",
  articleNotFound: "The advertisement does not exist or has been removed.",
  noAdsInCategory: "No ads in this category.",
  noAdsFound: "No ads matching the given criteria were found.",

  /* Search */
  searchTitle: "Search",
  searchBtn: "Search",
  allTypes: "All types",
  fields: {
    keyword: "Phrase",
    type: "Type",
    priceFrom: "Price from",
    priceTo: "Price to",
  },
  validation: {
    invalidPrice: "Invalid price value (max 2 decimal places).",
  },

  resultsTitle: (n) => (n === 1 ? "Found 1 ad" : `Found ${n} ads`),

  price: "Price",
  negotiatedPrice: "Price negotiable",
  priceNotSet: "-",
  readMore: "Read more ->",
  formatPrice: (value) => {
    try {
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "PLN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch {
      return `${value.toFixed(2)} PLN`;
    }
  },

  backToList: "<- Back to list",
  addAdvert: "Add an ad",

  contact: "Contact",
  city: "City",
  telephone: "Phone",
  email: "E-mail",

  contactForm: {
    title: "Send a message to the advertiser",
    submit: "Send",
    sending: "Sending...",
    fields: {
      name: "Full name",
      email: "E-mail",
      telephone: "Phone (optional)",
      text: "Message content",
      personalData:
        "I consent to the processing of my personal data for the purpose of replying to my message.",
    },
    validation: {
      requiredName: "Please provide your name.",
      requiredEmail: "Please provide an e-mail address.",
      invalidEmail: "Invalid e-mail address.",
      requiredText: "Please enter the message content.",
      requiredPersonalData:
        "Consent to the processing of personal data is required.",
    },
    status: {
      sendSuccess: "Your message has been sent. Thank you!",
      sendFailed: "The message could not be sent. Please try again shortly.",
      rateLimit:
        "You have exceeded the sending limit from this address. Please try again in an hour.",
      waitBeforeSubmit: (s) =>
        `Please wait ${s} s before sending (bot protection).`,
      networkError: (msg) =>
        `Network error: ${msg}. Please check your connection and try again.`,
      networkErrorGeneric:
        "An unexpected error occurred. Please check your connection and try again.",
    },
  },
};
